<template>
  <router-view v-if="hasReviewLoaded" v-slot="{ Component }">
    <keep-alive>
      <component :is="Component" />
    </keep-alive>
  </router-view>
</template>
<script setup lang="ts">
import { useRoute, useRouter } from "vue-router";
import useReview, { ReviewKey } from "./use-review";
import useLoading from "@app/composables/use-loading";
import { provide, ref } from "vue";
import { isAxiosError } from "axios";

const route = useRoute();
const router = useRouter();
const loading = useLoading();
const review = useReview(parseInt(route.params.id as string));
const hasReviewLoaded = ref(false);
provide(ReviewKey, review);

loading.start();
review
  .refresh()
  .then(() => {
    hasReviewLoaded.value = true;
  })
  .catch((e) => {
    if (isAxiosError(e) && e.response?.status === 404) {
      router.push("/404");
    } else throw e;
  })
  .finally(() => {
    loading.stop();
  });
</script>
